import { B000020FindResponse } from "clients/rest";
import { atom, SetterOrUpdater } from "recoil";

export type Menus = { [parent: string]: Menu };

type Menu = {
  label: string;
  open: boolean;
  pages: Pages;
};

export type Pages = {
  [children: string]: Page;
};

type Page = {
  nav: string;
  label: string;
  parameter?: string;
  eigyosyoKengen?: string;
};

const defaultValue: Menus = {
  "010": {
    label: "受注処理",
    open: false,
    pages: {
      "010010": { nav: "/b010010", label: "受注入力" },
      "010020": { nav: "/b010020", label: "受注照会" },
      "010030": { nav: "/b010030", label: "受注明細照会" },
      "010040": { nav: "/b010040", label: "受注チェックリスト" },
      "010050": { nav: "/b010050", label: "受注ワーク取込" },
      "010070": { nav: "/b010070", label: "受注ワーク照会" },
      "010080": { nav: "/b010080", label: "受注確定" },
    },
  },
  "020": {
    label: "売上処理",
    open: false,
    pages: {
      "020010": { nav: "/b020010", label: "売上入力" },
      "020020": { nav: "/b020020", label: "売上照会" },
      "020030": { nav: "/b020030", label: "売上明細照会" },
      "020040": { nav: "/b020040", label: "専用伝票発行" },
      "020050": { nav: "/b020050", label: "売上チェックリスト" },
    },
  },
  "030": {
    label: "売掛処理",
    open: false,
    pages: {
      "030010": { nav: "/b030010", label: "請求締処理" },
      "030020": { nav: "/b030020", label: "請求状況照会" },
      "030030": { nav: "/b030030", label: "請求書出力" },
      "030040": { nav: "/b030040", label: "請求明細照会" },
      "030050": { nav: "/b030050", label: "入金入力" },
      "030060": { nav: "/b030060", label: "売掛金残高一覧表" },
      "030070": { nav: "/b030070", label: "得意先元帳照会" },
      "030080": { nav: "/b030080", label: "得意先元帳出力" },
    },
  },
  "040": {
    label: "発注処理",
    open: false,
    pages: {
      "040010": { nav: "/b040010", label: "発注入力" },
      "040020": { nav: "/b040020", label: "発注照会" },
      "040030": { nav: "/b040030", label: "発注明細照会" },
      "040040": { nav: "/b040040", label: "発注完了入力" },
    },
  },
  "050": {
    label: "仕入処理",
    open: false,
    pages: {
      "050010": { nav: "/b050010", label: "仕入入力" },
      "050020": { nav: "/b050020", label: "仕入照会" },
      "050030": { nav: "/b050030", label: "仕入明細照会" },
    },
  },
  "060": {
    label: "製造処理",
    open: false,
    pages: {
      "060010": { nav: "/b060010", label: "製造チェック照会" },
      "060020": { nav: "/b060020", label: "トータル加工用リスト" },
      "060030": { nav: "/b060030", label: "受注生産品店別組立出荷リスト" },
    },
  },
  "070": {
    label: "入荷処理",
    open: false,
    pages: {
      "070010": { nav: "/b070010", label: "入荷予定実績照会" },
      "070020": { nav: "/b070020", label: "入荷・入庫一括確定" },
    },
  },
  "080": {
    label: "出荷処理",
    open: false,
    pages: {
      "080010": { nav: "/b080010", label: "出荷予定作成" },
      "080020": { nav: "/b080020", label: "出荷作業指示一覧" },
      "080030": { nav: "/b080030", label: "トータルピッキングリスト発行" },
      "080040": { nav: "/b080040", label: "店別ピッキングリスト発行" },
      "080050": { nav: "/b080050", label: "店別出荷数量訂正" },
      "080060": { nav: "/b080060", label: "出荷確定" },
      "080070": { nav: "/b080070", label: "出荷予定実績照会" },
      "080080": { nav: "/b080080", label: "バッチ関連照会" },
      "080090": { nav: "/b080090", label: "送り状向けファイル出力" },
    },
  },
  "090": {
    label: "在庫処理",
    open: false,
    pages: {
      "090010": { nav: "/b090010", label: "在庫照会(本社業務)" },
      "090011": { nav: "/b090011", label: "在庫照会(物流業務)" },
      "090020": { nav: "/b090020", label: "倉庫移動入力(本社業務)" },
      "090021": { nav: "/b090021", label: "倉庫移動入力(物流業務)" },
      "090030": { nav: "/b090030", label: "ロケーション移動入力" },
      "090040": { nav: "/b090040", label: "在庫調整入力" },
      "090050": { nav: "/b090050", label: "受払照会(本社業務)" },
      "090051": { nav: "/b090051", label: "受払照会(物流業務)" },
    },
  },
  "100": {
    label: "マスタメンテナンス",
    open: false,
    pages: {
      "100040": { nav: "/b100040", label: "部門マスタ" },
      "100050": { nav: "/b100050", label: "社員マスタ" },
      "100060": { nav: "/b100060", label: "得意先マスタ" },
      "100070": { nav: "/b100070", label: "得意先納入先マスタ" },
      "100080": { nav: "/b100080", label: "仕入先マスタ" },
      "100100": { nav: "/b100100", label: "倉庫マスタ" },
      "100110": { nav: "/b100110", label: "商品マスタ" },
      "100120": { nav: "/b100120", label: "商品分類マスタ" },
      "100130": { nav: "/b100130", label: "セット商品マスタ" },
      "100140": { nav: "/b100140", label: "単価マスタ" },
      "100150": { nav: "/b100150", label: "取引先別単価マスタ" },
      "100180": { nav: "/b100180", label: "ＷＨ単価マスタ" },
      "100190": { nav: "/b100190", label: "ロケーション管理マスタ" },
      "100220": { nav: "/b100220", label: "配送ルート割付マスタ" },
      "100230": { nav: "/b100230", label: "配送ルートバッチマスタ" },
    },
  },
  "110": {
    label: "月次統計処理",
    open: false,
    pages: {
      "110010": { nav: "/b110010", label: "月次更新" },
      "110020": { nav: "/b110020", label: "商品分類別売上実績表" },
      "110030": { nav: "/b110030", label: "担当者別取引日計表" },
      "110040": { nav: "/b110040", label: "担当者別目標設定" },
    },
  },
};

export type NavigateType = "menu" | "next" | "prev";

export const navigateTypeState = atom<NavigateType>({
  key: "menuNavigateState",
  default: "menu",
});

export const menusState = atom<Menus>({
  key: "menusState",
  default: defaultValue,
});

export const getMenus = (value: B000020FindResponse[]) => {
  const menus: Menus = {};
  value.forEach((data) => {
    const gyomuId = data.gamenId.substring(0, 3);
    const gamenId = data.gamenId;
    const menu = { ...defaultValue[gyomuId] };
    if (Object.keys(menu).length === 0) {
      return;
    }
    const pages = { ...menu.pages };
    if (Object.keys(pages).length === 0) {
      return;
    }
    const page = { ...pages[gamenId] };
    if (Object.keys(page).length === 0) {
      return;
    }
    if (!menus[gyomuId]) {
      menus[gyomuId] = {
        label: menu.label,
        open: menu.open,
        pages: {},
      };
    }
    if (!menus[gyomuId].pages[gamenId]) {
      menus[gyomuId].pages[gamenId] = {
        label: page.label,
        nav: page.nav,
        parameter: data.parameter,
        eigyosyoKengen: data.eigyosyoKengen,
      };
    }
  });
  return menus;
};

export const turnOpenMenu = (
  gyomuId: string,
  menus: Menus,
  setMenus: SetterOrUpdater<Menus>
) => {
  const menu = { ...menus[gyomuId] };
  menu.open = !menu.open;
  const copied = { ...menus };
  copied[gyomuId] = menu;
  setMenus(copied);
};
